import { Heading, VStack } from "@chakra-ui/react"
import { useCurrentActivity } from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import { formatActivityKind } from "@hydrologiq/shared/utils/activities/activityStatus"
import ActivityLoading from "./ActivityLoading"

function ActivityScreenWrapper({ children }: { children: React.ReactNode }) {
  const activity = useCurrentActivity()
  if (!activity) return <ActivityLoading />
  return (
    <VStack height="100%" width="100%" align="stretch">
      <Heading size="md" as="h3">
        {formatActivityKind(activity.kind)}: {activity.name}
      </Heading>
      {children}
    </VStack>
  )
}

export default ActivityScreenWrapper
